import UserRoleCURModule from "@/modules/UserRoleCUR";

function ViewUserRolePage() {
    return (
        <UserRoleCURModule typePage="view" />
    )
}

export default ViewUserRolePage;